import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=ff454724&scoped=true"
import script from "./Network.vue?vue&type=script&lang=js"
export * from "./Network.vue?vue&type=script&lang=js"
import style0 from "./Network.vue?vue&type=style&index=0&id=ff454724&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff454724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff454724')) {
      api.createRecord('ff454724', component.options)
    } else {
      api.reload('ff454724', component.options)
    }
    module.hot.accept("./Network.vue?vue&type=template&id=ff454724&scoped=true", function () {
      api.rerender('ff454724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/Network.vue"
export default component.exports